import Typography from '@mui/material/Typography';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  title: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    background: theme.palette.background.paper,
  },
}));

const SourceHeading: React.FC<{ className?: string }> = ({ className }) => {
  const { cx, classes } = useStyles();

  return (
    <Typography variant='bodyMedium' className={cx(classes.title, className)}>
      If a transaction matches this:
    </Typography>
  );
};

const TargetHeading: React.FC<{ className?: string }> = ({ className }) => {
  const { cx, classes } = useStyles();

  return (
    <Typography variant='bodyMedium' className={cx(classes.title, className)}>
      Then make these changes:
    </Typography>
  );
};

export { SourceHeading, TargetHeading };
